import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/RecommendationLibrarys`;

export const createRecommendationLibrary = async recommendationLibrary => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(recommendationLibrary),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateRecommendationLibrary = async recommendationLibrary => {
  const url = `${baseRoute}/${recommendationLibrary.recommendationLibraryId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(recommendationLibrary),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getRecommendationLibraryById = async recommendationLibraryId => {
  const url = `${baseRoute}/${recommendationLibraryId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getRecommendationLibrarys = async () => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const removeRecommendationLibraryById = async recommendationLibraryId => {
  const url = `${baseRoute}/${recommendationLibraryId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
    // body: JSON.stringify(recommendationLibrary),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};
